import _ from 'lodash';
import { IState } from 'store/customers/search';

const applySort = (state: IState) => {
	state.sortedResults = _.orderBy(state.results, state.sortField, state.sortDirection);
};
export const customerService = {
	applySort
};
